<template lang="html">
  <div class="loaderParent">
    <div class="loader d-block">
      <Navber></Navber>
      <div :style="width" class="mx-auto h-100 popupwidth overflowAuto" style="overflow: auto">
        <div v-if="state =='training'" class="row mt-4 justify-content-center">
          <div class="col-sm-12 p-5 m-5 col-md-12 card image">
            <i class="text-right" @click="crossClose">&#10005;</i>
            <h2 class="mb-4">Trigger Train</h2>
            <label class="text-left mb-2 ml-2">Select Options</label>
            <multiselect
                class="multi"
                v-model="selectedPolutant"
                :multiple="true"
                placeholder="Please Select"
                :options="getCurrentOption"
            ></multiselect>
            <div class="fields fields text-center my-4 py-3 my-4">
              <button class="button downloadButton" style="width: 50%" @click="startFunction()"><i v-if="loadershowHere" class="fas mr-3 fa-spinner fa-pulse"></i>Start Train</button>
            </div>
          </div>
        </div>
        <div v-if="state=='forecast'" class="card m-5 p-5">
          <i class="text-right mr-4" @click="crossClose">&#10005;</i>
          <h2 class="mb-0">Start Forecast</h2>
          <div class="row mt-4">
            <div class="col-sm-12 mt-4 form-group text-left col-md-6">
              <label class="labelClass">Forecast</label>
              <input type="number" class="form-control placeholderFont" v-model="forecastCount" placeholder="enter forecast count"/>
            </div>
            <div class="col-sm-12 mt-4 text-left form-group col-md-6">
              <label class="labelClass">Select Model</label>
              <select class="form-control inputFont" v-model="selectedModal">
                <option selected disabled value="">Please Select</option>
                <option v-for="(value, key) in allmodels" :key="key">{{value.model}}</option>
              </select>
            </div>
            <div class="col-sm-12 mt-4 text-left form-group col-md-6">
              <label class="labelClass">Target</label>
              <select class="form-control inputFont" v-model="selectedTarget" id="">
                <option disabled selected value="">Please Select</option>
                <option v-for="(value, key) in getCurrentOption" :key="key">{{value}}</option>
              </select>
            </div>
            <div class="col-sm-12 mt-5 text-left form-group col-md-6">
              <button class="button downloadButton" style="width: inherit" @click="startForecast()"><i v-if="loadershowHere" class="fas mr-3 fa-spinner fa-pulse"></i>Start Forecast</button>
            </div>
          </div>
        </div>
        <div v-if="state=='withoutFile'" class="card m-5 p-5">
          <i class="text-right mr-4" @click="crossClose">&#10005;</i>
          <h2 class="mb-0">Start Forecast</h2>
          <div class="row mt-4">
            <div class="col-sm-12 mt-4 form-group text-left col-md-6">
              <label>Model Name</label>
              <input type="text" class="form-control placeholderFont" v-model="modelName" placeholder="enter model name" />
            </div>
            <div class="col-sm-12 mt-4 form-group text-left col-md-6">
              <label class="labelClass">Forecast</label>
              <input type="number" class="form-control placeholderFont" v-model="forecastCount" placeholder="enter forecast count"/>
            </div>
            <div class="col-sm-12 mt-4 text-left form-group col-md-6">
              <label class="labelClass">Select Model</label>
              <select class="form-control inputFont" v-model="selectedModal">
                <option selected disabled value="">Please Select</option>
                <option v-for="(value, key) in allmodels" :key="key">{{value.model}}</option>
              </select>
            </div>
            <div class="col-sm-12 mt-5 text-left form-group col-md-6">
              <button class="button downloadButton" style="width: inherit" @click="forecastwithoutFile()"><i v-if="loadershowHere" class="fas mr-3 fa-spinner fa-pulse"></i>Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Toasted from "vue-toasted";
import Vue from "vue";
import { apiCall } from "@/utils/api";
import multiselect from "vue-multiselect";
import Navber from "./navbar";
import loader from "./loader";

Vue.use(Toasted);
export default {
  props: {
    allmodelData: {},
    modelTrainPollutant: {
      type: Object
    },
    state: {
      type: String
    }
  },
  components: {
    multiselect: multiselect,
    Navber: Navber,
    loader: loader
  },
  data() {
    return {
      modelName: "",
      forecastCount: 0,
      allmodels: [],
      selectedModal: "",
      selectedTarget: "",
      loadershowHere: false,
      look_back: 0,
      look_forward: 0,
      selectedPolutant: [],
      selectedModeInfo: {}
    };
  },
  watch: {
    selectedModal(newVal, oldVal) {
      this.selectedModeInfo = this.allmodels.filter(data => {
        return data.model === newVal;
      })[0];
    }
  },
  mounted() {
    this.getOPtions();
    this.modelContent = this.content;
  },
  computed: {
    width() {
      if (this.state === "training") {
        return "width: 40%";
      } else if (this.state === "forecast") {
        return "width: 80%";
      }
    },
    getCurrentOption() {
      if (this.state === "training") {
        return this.modelTrainPollutant["pre_process"].selectedOptions;
      } else if (this.state === "forecast") {
        return this.modelTrainPollutant["numerical_features"];
      }
    }
  },
  methods: {
    getOPtions() {
      const url = `users_Model`;
      apiCall({ url, method: "get" })
        .then(resp => {
          this.allmodels = resp.data;
        })
        .catch(err => {
          this.loaderShow = false;
          console.log(err);
        });
    },
    forecastwithoutFile() {
      this.loadershowHere = true;
      const url = `auto_ml/forecastwithoutFile`;
      const body = {
        name: this.modelName,
        withFile: false,
        s3_bucket_name: "ambee-forecast-auto-train",
        model: this.selectedModeInfo["model"],
        model_report_file: this.selectedModeInfo["model_report_file"],
        forecast_time_step: parseInt(this.forecastCount)
      };
      apiCall({ url: url, data: body, method: "put" })
        .then(r => {
          this.loadershowHere = false;
          this.crossClose();
          this.$emit("updateit");
        })
        .catch((err) => {
          this.loadershowHere = false;
          this.crossClose();
          console.log("error", err);
        });
    },
    startForecast() {
      this.loadershowHere = true;
      const url = `auto_ml/${this.modelTrainPollutant._id}/forecast`;
      const body = {
        withFile: true,
        filename: this.modelTrainPollutant["pre_process"].filename,
        s3_bucket_name: this.modelTrainPollutant["bucket_name"],
        target: [this.selectedTarget],
        auto_ml_id: this.modelTrainPollutant["_id"],
        user_id: this.modelTrainPollutant["userId"],
        // name: this.modelTrainPollutant["name"],
        model: this.selectedModeInfo["model"],
        model_report_file: this.selectedModeInfo["model_report_file"],
        datetime_column: this.modelTrainPollutant["datetime_column"],
        forecast_time_step: parseInt(this.forecastCount)
      };
      apiCall({ url: url, data: body, method: "put" })
        .then(r => {
          this.loadershowHere = false;
          this.crossClose();
          this.modelTrainPollutant["forecast"].status = "Started";
          this.$emit("updateit");
        })
        .catch(err => {
          this.loadershowHere = false;
          this.crossClose();
          console.log("error", err);
        });
    },
    startFunction() {
      this.loadershowHere = true
      if (this.state === "training") {
        const body = {
          filename: this.modelTrainPollutant["pre_process"].filename,
          s3_bucket_name: this.modelTrainPollutant["bucket_name"],
          target: this.selectedPolutant,
          auto_ml_id: this.modelTrainPollutant["_id"],
          user_id: this.modelTrainPollutant["userId"],
          name: this.modelTrainPollutant["name"]
        };
        const url = `auto_ml/${this.modelTrainPollutant._id}/training`;
        apiCall({ url: url, data: body, method: "put" })
          .then(r => {
            this.loadershowHere = false;
            this.crossClose();
            this.modelTrainPollutant["training"].status = "Started";
            this.$emit("updateit");
          })
          .catch(err => {
            this.crossClose();
            console.log("error", err);
          });
      }
    },
    triggerTrain() {},
    crossClose() {
      this.$emit("closePopup");
    }
  }
};
</script>
<style scoped>
.popupwidth::-webkit-scrollbar {
  display: none;
}
.image {
  background-image: url("../assets/download.png");
}
.downloadButton {
  width: 20rem;
  height: 5rem;
}
.button {
  width: 6rem;
  height: 3rem;
  /* margin: 1rem; */
  border: 1px solid blue;
  color: white;
  background: cadetblue;
  /* padding: 1rem; */
  border-radius: 20px;
}
@media screen and (max-width: 34em) {
  .popupwidth {
    width: 100% !important;
  }
  .loader {
    /* left: 25% !important; */
  }
}
.loaderParent {
  height: 100%;
  width: 100%;
  z-index: 99 !important;
  position: fixed;
  top: 0px;
  left: 0px;
  opacity: 0.98;
  background: #2c3e50;
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999 !important;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background: #2c3e50;
  opacity: 0.98;
}

.spinner {
  height: 15vh;
  width: 15vh;
  border: 6px solid rgba(0, 174, 239, 0.2);
  border-top-color: rgba(0, 174, 239, 0.8);
  border-radius: 100%;
  animation: rotation 0.6s infinite linear 0.25s;
  opacity: 0;
}

@keyframes rotation {
  from {
    opacity: 1;
    transform: rotate(0deg);
  }
  to {
    opacity: 1;
    transform: rotate(359deg);
  }
}
#exampleModalLongTitle {
  font-family: "ubuntu";
  font-size: 34px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}
.roundedBox {
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  border-radius: 10px;
  height: 400px;
}
</style>
